{
    "RunondayMonthLabel": "Exécuter le jour (mois) :",
    "RunondayWeekLabel": "Exécuter le jour (semaine) :",
    "RunondaysLabel": "Exécuter le rapport sur les jours :",
    "RunbetweenhoursStartLabel": "Exécuter entre les heures :",
    "RunbetweenhoursEndLabel": "Et :",
    "RunbetweenhoursNote": "(Compris sur toute l'heure de fin)",
    "RunatminuteHourLabel": "Run At Minute (Hour) :",
    "RunatminuteHourNote": "Passé chaque heure (approximatif)",
    "RunondateLabel": "Exécuter le rapport à la date :",
    "RunattimeLabel": "Durée de fonctionnement (approx.) :",
    "TimeOptions_SectionHeader": "Options de temps",
    "NAME": "TimeOptions"
}